// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  name: __t.string(),
  owner: __t.identity(),
  worldSeed: __t.byteArray().name("world_seed"),
  createdAt: __t.timestamp().name("created_at"),
  chronicleSeq: __t.u64().name("chronicle_seq"),
  heroesPerHuman: __t.u8().name("heroes_per_human"),
  storyteller: __t.u8(),
});
